var _config = {
    apiUrl: 'http://static.in.xl9.xunlei.com/movie/doubanComments/',
    start: 0,
    nums: 3
}

function DoubanComments(doubanid) {
    return $.ajax({
        url: _config.apiUrl + doubanid + '/' + _config.start + '/' + _config.nums,
        dataType: 'jsonp',
        jsonpCallback: 'doubanComments',
        cache: true,
        timeout: 5000
    });
}

DoubanComments.config = function (obj) {
    for (var i in obj) {
        _config[i] = obj[i];
    };
}


module.exports = DoubanComments;


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/douban_comments.js
// module id = 67
// module chunks = 10